import { render } from "./UpsellGraphic.vue?vue&type=template&id=0b7f9c48"
const script = {}

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__